export default __webpack_public_path__ + "static/media/087-hotel.c2990a6c.svg";